<template>
  <div
      v-if="!visible"
      :class="{'outer': true, 'outer-mobile': viewMode === 'phone'}"
      @mouseover="outerTarget"
      @click="stopProp"
  >
    <div
        :class="{'inner': true, 'inner-mobile': viewMode === 'phone'}"
        :style="{'width': computedWidth, 'height':computedHeight}"
        @click="stopProp"
    >
      <template v-for="obj in undoRedoManager.VDom">
        <component :is="obj.node.tag" :key="obj.key" :fb-node="obj.node" v-bind="obj.node.data.props"></component>
      </template>
    </div>
  </div>

</template>

<script>
import FirebaseNodeV3 from '../../base/FirebaseNode'
import CPopupBuilder from "../../../editor/nodes/CPopupBuilder.vue";
import Block from "./Block.vue";
import {PopUpUndoRedoManagerV3} from "../../../../store/services/popUpUndoRedoManager";

export default CPopupBuilder.extend({
  name: "CPopupBuilderV3",
  components: {
    'block': Block,
  },
  mixins: [FirebaseNodeV3],
  computed: {
    computedWidth () {
      return this.isFullScreen === true || this.popupWidth === '100vw' ? '100%'  :  this.popupWidth
    },
    computedHeight () {
      return this.isFullScreen === true || this.popupHeight === '100vh' ? '100vh' : this.popupHeight
    },
    clonedVDom: {
      get () {
        return this.undoRedoManager.VDom
      },
      set () {

      }
    }
  },
  data() {
    return {
      undoRedoManager: new PopUpUndoRedoManagerV3(),
    }
  }
})
</script>
